import axios from "axios";
import { urlAPI_Current } from "./config";

async function userLogged(){
    try{
        const responseProfile = await axios.post(`${urlAPI_Current}/getProfile`, {}, {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
            }
        });
        return responseProfile.data.user;
    }catch(err){
        console.log(err)
    }
}

export { userLogged };